import { useTranslation } from "react-i18next";

export default function Testimonial() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-3xl bg-foreground-950 overflow-hidden flex flex-col lg:flex-row">
          <div className="lg:w-2/5 relative min-h-[320px] lg:min-h-[500px]">
            <img
              src="https://readdy.ai/api/search-image?query=Confident%20modern%20entrepreneur%20in%20casual%20blazer%20leaning%20against%20sunlit%20exposed%20brick%20wall%2C%20warm%20natural%20lighting%20from%20large%20loft%20window%2C%20genuine%20relaxed%20expression%2C%20editorial%20business%20portrait%20photography%2C%20soft%20warm%20earth%20tones%2C%20inspiring%20yet%20approachable%20professional%20atmosphere&width=800&height=1000&seq=testimonial-v2-2026&orientation=portrait"
              alt="Entrepreneur testimonial"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-foreground-950/30 lg:bg-gradient-to-r lg:from-transparent lg:to-foreground-950/60"></div>
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center px-8 py-10 md:px-14 md:py-16 relative">
            <span className="text-6xl md:text-8xl font-heading text-background-100/15 leading-none mb-4">
              &ldquo;
            </span>
            <blockquote className="text-lg md:text-xl lg:text-2xl text-background-50 leading-relaxed mb-8 -mt-8">
              {t("testimonial.quote")}
            </blockquote>
            <div className="mb-8">
              <p className="text-base font-semibold text-background-50">
                {t("testimonial.name")}
              </p>
              <p className="text-sm text-background-100/50 mt-0.5">
                {t("testimonial.role")}
              </p>
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-accent-600 transition-colors w-fit"
            >
              {t("testimonial.cta")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}